import chrevonLeftDarkArrowIcon from "@assets/icon-chevron-left-dark.svg";
import chrevonRightLightArrowIcon from "@assets/icon-chevron-right-light.svg";
import emailIcon from "@assets/icon-email.svg";
import emailV3Icon from "@assets/icon-email-v3.svg";
import facebookIcon from "@assets/icon-facebook.svg";
import instagramIcon from "@assets/icon-instagram.svg";
import linkedinIcon from "@assets/icon-linkedin.svg";
import telegramIcon from "@assets/icon-telegram.svg";
import twitterIcon from "@assets/icon-twitter.svg";
import whatsappIcon from "@assets/icon-whatsapp.svg";
import bookmarkIcon from "@assets/icons/icon-bookmark.svg";
import closeWhite from "@assets/icons/icon-close-white.svg";
import emailWhiteIcon from "@assets/icons/icon-email-white.svg";
import facebookWhiteIcon from "@assets/icons/icon-facebook-white.svg";
import feedbackIcon from "@assets/icons/icon-feedback.svg";
import followIcon from "@assets/icons/icon-follow.svg";
import giftIcon from "@assets/icons/icon-gift.svg";
import hamburgerForDesktopIcon from "@assets/icons/icon-hamburger-desktop.svg";
import hamburgerForMobileIcon from "@assets/icons/icon-hamburger-mobile.svg";
import linkIcon from "@assets/icons/icon-link.svg";
import linkedinWhiteIcon from "@assets/icons/icon-linkedin-white.svg";
import moreIcon from "@assets/icons/icon-more.svg";
import playIcon from "@assets/icons/icon-play.svg";
import playLineIcon from "@assets/icons/icon-play-line.svg";
import preferencesIcon from "@assets/icons/icon-preferences.svg";
import printIcon from "@assets/icons/icon-print.svg";
import profileIcon from "@assets/icons/icon-profile.svg";
import reuseIcon from "@assets/icons/icon-reuse.svg";
import searchIcon from "@assets/icons/icon-search.svg";
import shareIcon from "@assets/icons/icon-share.svg";
import shareLineIcon from "@assets/icons/icon-share-line.svg";
import shareLineWhite from "@assets/icons/icon-share-line-white.svg";
import telegramWhiteIcon from "@assets/icons/icon-telegram-white.svg";
import twitterWhiteIcon from "@assets/icons/icon-twitter-white.svg";
import unfollowIcon from "@assets/icons/icon-unfollow.svg";
import whatsappWhiteIcon from "@assets/icons/icon-whatsapp-white.svg";

import { IconTypeEnum } from "./types";

export const getIconSrc = (icon: IconTypeEnum) => {
  switch (icon) {
    case IconTypeEnum.facebook:
      return facebookIcon;

    case IconTypeEnum.telegram:
      return telegramIcon;

    case IconTypeEnum.email:
      return emailIcon;

    case IconTypeEnum.linkedin:
      return linkedinIcon;

    case IconTypeEnum.twitter:
      return twitterIcon;

    case IconTypeEnum.whatsapp:
      return whatsappIcon;

    case IconTypeEnum.instagram:
      return instagramIcon;

    case IconTypeEnum.profile:
      return profileIcon;

    case IconTypeEnum.search:
      return searchIcon;

    case IconTypeEnum.hamburgerForDesktop:
      return hamburgerForDesktopIcon;

    case IconTypeEnum.hamburgerForMobile:
      return hamburgerForMobileIcon;

    case IconTypeEnum.gift:
      return giftIcon;

    case IconTypeEnum.closeWhite:
      return closeWhite;

    case IconTypeEnum.share:
      return shareIcon;

    case IconTypeEnum.link:
      return linkIcon;

    case IconTypeEnum.play:
      return playIcon;

    case IconTypeEnum.playLine:
      return playLineIcon;

    case IconTypeEnum.shareLine:
      return shareLineIcon;

    case IconTypeEnum.bookmark:
      return bookmarkIcon;

    case IconTypeEnum.more:
      return moreIcon;

    case IconTypeEnum.print:
      return printIcon;

    case IconTypeEnum.preferences:
      return preferencesIcon;

    case IconTypeEnum.follow:
      return followIcon;

    case IconTypeEnum.feedback:
      return feedbackIcon;

    case IconTypeEnum.reuse:
      return reuseIcon;

    case IconTypeEnum.chrevonLeftDarkArrow:
      return chrevonLeftDarkArrowIcon;

    case IconTypeEnum.chrevonRightLightArrow:
      return chrevonRightLightArrowIcon;

    case IconTypeEnum.unfollow:
      return unfollowIcon;

    case IconTypeEnum.emailV3:
      return emailV3Icon;

    case IconTypeEnum.shareLineWhite:
      return shareLineWhite;

    case IconTypeEnum.facebookWhite:
      return facebookWhiteIcon;

    case IconTypeEnum.telegramWhite:
      return telegramWhiteIcon;

    case IconTypeEnum.emailWhite:
      return emailWhiteIcon;

    case IconTypeEnum.linkedinWhite:
      return linkedinWhiteIcon;

    case IconTypeEnum.twitterWhite:
      return twitterWhiteIcon;

    case IconTypeEnum.whatsappWhite:
      return whatsappWhiteIcon;
  }
};
